import * as Yup from 'yup';

import { ArtworkType } from 'types';

export const LoginFormValidation = Yup.object().shape({
  email: Yup.string()
    .required('Login is required!')
    .email('Login is invald!')
    .max(64, 'Login is too long!'),
  password: Yup.string().required('Password is required!'),
});

export const CreateArtworkFormValidation = Yup.object().shape({
  name: Yup.string().required('Name is required!').max(150, 'Name is too long!'),
  triggeredQrcodeOnly: Yup.boolean(),
  pointerImage: Yup.mixed()
    .nullable()
    .when('triggeredQrcodeOnly', (triggeredQrcodeOnly: boolean, schema: Yup.SchemaOf<'mixed'>) => {
      return triggeredQrcodeOnly
        ? schema
        : schema
            .required('Pointer image is required!')
            .test(
              'fileSize',
              'File is too large!',
              (value: File | null | string) =>
                value && (typeof value === 'string' || value.size <= 1e7),
            );
    }),
  type: Yup.string().nullable().required('Type is required!'),
  imageMedia: Yup.mixed()
    .nullable()
    .when('type', (type: ArtworkType, schema: Yup.SchemaOf<'mixed'>) => {
      return type === 'image'
        ? schema
            .required('File are required!')
            .test(
              'filesSize',
              'File are too large!',
              (value: File | null | string) =>
                value && (typeof value === 'string' || value.size <= 5e8),
            )
        : schema;
    }),
  videoMedia: Yup.mixed()
    .nullable()
    .when('type', (type: ArtworkType, schema: Yup.SchemaOf<'mixed'>) => {
      return type === 'video'
        ? schema
            .required('File are required!')
            .test(
              'filesSize',
              'File are too large!',
              (value: File | null | string) =>
                value && (typeof value === 'string' || value.size <= 5e8),
            )
        : schema;
    }),
  iOSModel: Yup.mixed()
    .nullable()
    .when('type', (type: ArtworkType, schema: Yup.SchemaOf<'mixed'>) => {
      return type !== '3d'
        ? schema
        : schema
            .required('3d model (.usdz) file is required!')
            .test(
              'fileSize',
              'File is too large!',
              (value: File | null | string) =>
                value && (typeof value === 'string' || value.size <= 5e7),
            );
    }),
  androidModel: Yup.mixed()
    .nullable()
    .when('type', (type: ArtworkType, schema: Yup.SchemaOf<'mixed'>) => {
      return type !== '3d'
        ? schema
        : schema
            .required('3d model (.glb) file is required!')
            .test(
              'fileSize',
              'File is too large!',
              (value: File | null) => value && (typeof value === 'string' || value.size <= 5e7),
            );
    }),
});
